// Ported verbatim from vue3/src/features/customer-display/scheduling.js
// (pure, framework-independent - see format.js's header for why this is
// duplicated rather than moved into shared/).
//
// setTimeout's delay is a 32-bit signed int; anything larger overflows and
// fires almost immediately instead of waiting - never schedule more than
// this in one shot.
const MAX_DELAY_MS = 60000;

// Drift-safe wait until an absolute instant (ISO string) elapses, re-checking
// in bounded steps rather than scheduling the full remaining time at once.
// Calls onExpire() exactly once: immediately if already passed, otherwise
// after however many bounded re-checks it takes to get there. A blank or
// unparseable instant means "no deadline" - onExpire is never called, and
// the returned cancel is still safe to call.
export function watchUntil(isoInstant, onExpire) {
  let timer = null;
  function check() {
    const at = Date.parse(isoInstant);
    if (!Number.isFinite(at)) return;
    const msLeft = at - Date.now();
    if (msLeft <= 0) {
      onExpire();
      return;
    }
    timer = setTimeout(check, Math.min(msLeft, MAX_DELAY_MS));
  }
  check();
  return () => clearTimeout(timer);
}

// One bounded-safe wait for a plain duration (ms) rather than an absolute
// deadline - used by the post-rating screen's fixed display duration, which
// can be configured arbitrarily large.
export function scheduleAfter(ms, callback) {
  let elapsed = 0;
  let timer = null;
  function tick() {
    const step = Math.min(Math.max(ms - elapsed, 0), MAX_DELAY_MS);
    elapsed += step;
    timer = setTimeout(() => {
      if (elapsed >= ms) callback();
      else tick();
    }, step);
  }
  tick();
  return () => clearTimeout(timer);
}
